<template>
  <div />
</template>

<script>
import defaultHeadMeta from '@/mixins/defaultHeadMeta'
import { mapGetters } from 'vuex'

export default {
  name: 'MarketsPair',
  mixins: [defaultHeadMeta],
  computed: {
    ...mapGetters({
      marketPairs: 'pairs/marketPairs',
    }),
  },
  created () {
    const pair = this.marketPairs.find(
      p =>
        p.pairName.toLowerCase().replace(/_/g, '') ===
        (this.$route.params.id || '').toLowerCase(),
    )
    this.$router.push(pair ? `/exchange/${pair?.name}` : '/not-found')
  },
}
</script>

<style scoped></style>
